document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 992) return;

  const topItems = document.querySelectorAll('.gsp-main-menu > .gsp-menu-item');

  topItems.forEach((topItem) => {
    const submenu = topItem.querySelector(':scope > ul.gsp-submenu--collections');
    if (!submenu) return;

    const secondLevelItems = submenu.querySelectorAll('.gsp-submenu-list > .gsp-submenu-item');
    if (!secondLevelItems.length) return;

    const grandchildMenus = submenu.querySelectorAll('.gsp-grandchild-menu');
    const topLink = topItem.querySelector(':scope > .gsp-menu-link');
    const imageWrap = submenu.querySelector('.gsp-riviera-image-wrap');
    const imageLink = submenu.querySelector('.gsp-riviera-image-link');

    const defaultImage = imageWrap?.dataset.defaultImage || topLink?.dataset.menuImage || '';
    const defaultAlt = imageWrap?.dataset.defaultAlt || topLink?.dataset.menuImageAlt || topLink?.textContent.trim() || '';
    const defaultHref = topLink?.getAttribute('href') || '#';

    if (!imageWrap || !imageLink) return;

    function renderPlaceholder() {
      imageWrap.innerHTML =
        '<div class="gsp-image gsp-image__placeholder gsp-collection-thumb-primary" style="--aspect-ratio: 33/42;"></div>';
    }

    function renderImage(src, alt) {
      imageWrap.innerHTML = '';
      const img = document.createElement('img');
      img.className = 'gsp-riviera-image';
      img.src = src;
      img.alt = alt || '';
      img.loading = 'lazy';
      imageWrap.appendChild(img);
    }

    function updateImage(src, alt, href) {
      imageLink.setAttribute('href', href || defaultHref);
      if (src) renderImage(src, alt || defaultAlt);
      else renderPlaceholder();
    }

    function clearActive() {
      secondLevelItems.forEach((item) => item.classList.remove('is-active'));
      grandchildMenus.forEach((menu) => menu.classList.remove('is-active'));
    }

    function setActive(item) {
      if (!item) return;

      clearActive();
      item.classList.add('is-active');

      const key = item.dataset.grandchildKey;
      if (key) {
        const relatedMenu = submenu.querySelector(`.gsp-grandchild-menu[data-grandchild-key="${key}"]`);
        if (relatedMenu) relatedMenu.classList.add('is-active');
      }

      const link = item.querySelector(':scope > .gsp-submenu-link');
      const src = link?.dataset.menuImage || defaultImage;
      const alt = link?.dataset.menuImageAlt || link?.textContent.trim() || defaultAlt;
      const href = link?.getAttribute('href') || defaultHref;

      updateImage(src, alt, href);
    }

    const firstItem = secondLevelItems[0];
    if (firstItem) setActive(firstItem);

    topItem.addEventListener('mouseenter', () => {
      topItem.classList.add('is-open');
      setActive(secondLevelItems[0]);
    });

    secondLevelItems.forEach((item) => {
      item.addEventListener('mouseenter', () => setActive(item));
    });

    topItem.addEventListener('mouseleave', () => {
      topItem.classList.remove('is-open');
      setActive(secondLevelItems[0]);
    });
  });
});